import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  Typography,
  CardHeader,
  CardContent,
  Stack,
  Box,
  Divider,
  Chip,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import errorHandler from "../../utils/errorHandler";
import CardLayout from "../../layouts/CardLayout";
import { IMAGE_BASE } from "../../utils/constants";
import { brandServices } from "../../services/AllServices";

const ViewMake = () => {
  const { id } = useParams();
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await brandServices.getBrandById({ id: id });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };

    fetchData();
  }, [id]);

  // Helper to format ISO date strings to readable format
  const formatDate = (isoDate) =>
    isoDate ? new Date(isoDate).toLocaleString() : "-";

  return (
    <Box>
      <Helmet>
        <title>View Brand</title>
      </Helmet>
      <CardLayout>
        <CardHeader title="View Brand" />
        <CardContent>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }} md={12}>
              <Card sx={{ boxShadow: 4, borderRadius: 3, overflow: "hidden" }}>
                <CardContent>
                  <Stack spacing={2} alignItems="center" textAlign="center">
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", mb: 1 }}>
                      <Box
                        component="img"
                        src={data?.brandLogo ? IMAGE_BASE + data.brandLogo : ""}
                        alt={data?.name || "Brand Image"}
                        sx={{
                          maxWidth: 320,
                          maxHeight: 320,
                          width: "100%",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                    </Box>

                    <Typography variant="h6" sx={{ mt: 0.5 }}>
                      {data?.name || "-"}
                    </Typography>

                    <Chip
                      size="small"
                      label={data?.status === 1 ? "Active" : "Inactive"}
                      color={data?.status === 1 ? "success" : "default"}
                    />

                    {data?.description && (
                      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
                        {data.description}
                      </Typography>
                    )}

                    <Divider sx={{ width: "100%", my: 1 }} />

                    <Stack direction="row" spacing={2} divider={<Divider orientation="vertical" flexItem />}>
                      <Box>
                        <Typography variant="caption" color="text.secondary">Created</Typography>
                        <Typography variant="body2">{formatDate(data?.createdAt)}</Typography>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="text.secondary">Updated</Typography>
                        <Typography variant="body2">{formatDate(data?.updatedAt)}</Typography>
                      </Box>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </CardContent>
      </CardLayout>
    </Box>
  );
};

export default ViewMake;
